<template>
  <responsive-drawer-header :hasDrawer="false" :color="theme.appBar.other.color" :moduleUnreadCount="unreadCount">
    <template v-slot:drawer-module-title> {{ mx_moduleTitle }}</template>
    <template v-slot:drawer-subtitle>
      {{ questionnaireTitle }}
    </template>

    <template v-slot:left-module-title>
      <span v-if="smAndDown" class="truncated-title">{{ questionnaireTitle }}</span>
      <span v-else>{{ questionnaireTitle }}</span>
    </template>
    <template v-slot:left-subtitle>{{ topicTitle }}</template>

    <template v-slot:right>
      <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="smAndDown" v-on="on" v-bind="attrs" elevation="0" flat color="error" class="mx-2">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn v-else-if="mdAndUp" v-on="on" elevation="0" color="error" class="mx-2"
            ><span style="font-weight: bold">{{ $t('bf.deleteForm') }}</span></v-btn
          >
        </template>

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">{{ $t('bf.evaluation.delete.rating.title') }}</v-card-title>

          <v-card-text class="mt-4 red--text">
            {{ $t('bf.evaluation.delete.rating.description') }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="onDelete"> {{ $t('fahrdienst.delete') }} </v-btn>

            <v-btn color="primary" text @click="onCancel">{{ $t('fahrdienst.cancel') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </responsive-drawer-header>
</template>

<script>
import common from '@/mixins/common';
import { mapActions, mapState } from 'vuex';
import index from './index.js';
import configMixin from '@/mixins/configMixin';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';

export default {
  name: 'BegleitfahrtBewertungViewHeader',
  components: {
    ResponsiveDrawerHeader,
  },
  mixins: [common, configMixin],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapState('begleitfahrt', ['questionnaireById', 'unreadCount', 'userById', 'questionnaireLocalData', 'questionnaireTopicById']),
    ...mapActions('begleitfahrt', ['deleteQuestionnaireDataInStateAndStorage']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, 1);
    },
    currentQuestionnaire() {
      return this.questionnaireById[this.$route.params.questionnaireId];
    },
    userId() {
      return this.$route.params.userId;
    },
    user() {
      return this.userById[this.userId];
    },
    uuid() {
      return this.$route.params.uuid;
    },
    drawerSubtitle() {
      switch (this.$route.name) {
        case 'begleitfahrt-bewertung-formular':
          return this.$t('bf.evaluationSections');
      }
      return '';
    },
    questionnaireTitle() {
      if (this.currentQuestionnaire && this.user) {
        const firstName = this.user.firstname || '';
        const lastName = this.user.lastname || '';
        return `${this.currentQuestionnaire.title}: ${firstName} ${lastName} `;
      }
      if (this.$route.name === 'begleitfahrt-mitarbeiter' && this.user) {
        return this.$t('bf.assessments');
      }
      return '';
    },
    topicTitle() {
      if (!Object.hasOwn(this.questionnaireLocalData, this.userId) || !Object.hasOwn(this.questionnaireLocalData[this.userId], this.uuid)) {
        // Assumption: Questionnaire is not persisted -> return default
        return this.$t('bf.basedata');
      }
      const questionnaireData = this.questionnaireLocalData[this.userId][this.uuid];
      const selectedTopicId = questionnaireData.selectedTopicId;
      if (Object.hasOwn(this.questionnaireTopicById, selectedTopicId)) {
        const topicName = this.questionnaireTopicById[selectedTopicId].title;
        return topicName;
      }
      switch (selectedTopicId) {
        case 'basedata':
          return this.$t('bf.basedata');

        case 'note':
          return this.$t('bf.note');

        case 'review':
          return this.$t('bf.review');

        case 'overallGrade':
          return this.$t('bf.overallGrade');

        case 'complete':
          return this.$t('bf.complete');

        default:
          return selectedTopicId;
      }
    },
  },
  methods: {
    onDelete() {
      this.deleteStoreAndLocalStorage();
    },
    onCancel() {
      this.dialog = false;
    },
    deleteStoreAndLocalStorage() {
      const userId = this.userId;
      const uuid = this.uuid;
      this.$store.dispatch('begleitfahrt/deleteQuestionnaireDataInStateAndStorage', { userId, uuid, markedAsDeleted: true });
      this.$router.replace({
        name: 'begleitfahrt-mitarbeiter',
        params: { instance: this.$route.params.instance, userId: userId.toString() },
      });
    },
  },
};
</script>
<style scoped>
.truncated-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70vw;
}
</style>
